import React, { useEffect, useRef, useState } from "react";


interface CounterProps {
  initialTimerValue: number,
  finalTimerValue: number,
  callback: () => void,
  timerCallback?: (timer: number) => void,
  returnType?: string,
}

// down counter which decreases till finalTimerValue
// intitialTimerValue and finalTimerValue needed to be provided
// callback can also be provided after the timer is stopped
export const DownCounter = ({
  initialTimerValue, // in seconds
  finalTimerValue, // in seconds
  callback, // after stopping timeout callback is called
  timerCallback, // callback for timer
  returnType,
}: CounterProps) => {
  const timeRef = useRef(null);
  const [timer, setTimer] = useState(initialTimerValue);

  useEffect(() => {
    // set timeout incase of timer value greater than finaltimer value
    if (timer > finalTimerValue) {
      timeRef.current = setTimeout(() => {
        if (timer > finalTimerValue) {
          setTimer(timer - 1);
          if (timerCallback) timerCallback(timer);
        }
      }, 1000);
    }

    // clear timeout as we have reached finalTimerValue
    if (timer <= finalTimerValue) {
      if (timerCallback) timerCallback(finalTimerValue);
      clearTimeout(timeRef.current);
      // call if provided in props
      if (callback) {
        callback();
      }
    }

    return () => clearTimeout(timeRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer, finalTimerValue, callback]);

  if (returnType) return null;
  return (
    <div>
      {timer < 10 ? `0${timer}` : timer}
    </div>
  );
};
